<template>
  <div
    class="yh-label-input"
    :style="{ height: height, width: width }"
    @click="clickInput"
  >
    <div class="yh-tag-box" ref="tagBox">
      <el-tag
        v-for="(tag, index) in tags"
        :key="index"
        closable
        @close="delTag(index)"
        class="yh-tag"
        >{{ tag }}</el-tag
      >
    </div>
    <el-input
      v-model.trim="inputData"
      ref="testInput"
      @keydown.enter.native="addTag"
      class="yh-tag-input"
      :maxlength="maxTag"
      :placeholder="placeholder"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "inputTag",
  props: {
    width: {
      default: "100px",
      type: String
    },
    height: {
      default: "40px",
      type: String
    },
    maxTag: {
      default: 50,
      type: Number
    },
    labelName: {
      type: String,
      default: ""
    },
    split: {
      type: String,
      default: ","
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      inputData: "",
      tags: []
    };
  },
  methods: {
    delTag(index) {
      this.tags.splice(index, 1);
      let tagStr = this.tags.toString();
      this.$emit("saveTag", tagStr);
    },
    addTag() {
      if (this.tags.find(item => item == this.inputData)) {
        return this.$message.warning("已存在" + this.inputData + "标签");
      }
      if (!this.inputData) return;
      // let length = this.inputData.split(this.split).length;
      // // if (length > 2) {
      // //   return this.$message.warning(`标签格式应为A${this.split}B，或者B`);
      // // }
      this.tags.push(...this.inputData.split(this.split));
      let tagStr = this.tags.toString();
      this.$emit("saveTag", tagStr);
      this.inputData = "";
    },
    clickInput() {
      this.$refs.testInput.focus();
    }
  },
  mounted() {
    if (this.labelName) {
      this.tags = this.labelName.split(",");
    }
  }
};
</script>

<style lang="scss" scoped>
.yh-label-input {
  position: relative;
  overflow: auto;
  border: 1px solid #ccc;
  .yh-tag-box {
    display: flex;
    z-index: 999;
    align-items: center;
    flex-wrap: wrap;
    .yh-tag {
      margin-left: 10px;
      margin-top: 10px;
    }
  }
  .yh-tag-input {
    /deep/ .el-input__inner {
      border: 0;
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// inputTag.vue?80569fe2